export default [
  {
    path: '/test/formula',
    name: 'test',
    component: () => import('@/components/formula/Formula.vue'),
    meta: {
      pageTitle: 'Página de Testes',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Página de Testes', active: true }
      ]
    }
  },
  {
    path: '/test/api',
    name: 'test-api',
    component: () => import('@/views/pages/ApiTest.vue'),
    meta: {
      pageTitle: 'Página de Testes da Api',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Página de Testes da Api', active: true }
      ]
    }
  },
  {
    path: '/dev/icon-list',
    name: 'icon-list',
    component: () => import('@/views/apps/dev/IconList.vue'),
    meta: {
      pageTitle: 'Developer',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Developer', active: true }
      ]
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/pages/Profile.vue'),
    meta: {
      pageTitle: 'Meu Perfil',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Perfil', active: true }
      ]
    }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/views/pages/Notifications.vue'),
    meta: {
      pageTitle: 'Notificações',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Notificações', active: true }
      ],
      searchable: false
    }
  },
  // User
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/apps/users/Index.vue'),
    meta: {
      rule: 'users.menu',
      pageTitle: 'Usuários',
      icon: 'UsersIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Usuários', active: true }
      ]
    }
  },
  {
    path: '/integrations',
    name: 'integrations',
    component: () => import('@/views/apps/integrations/Index.vue'),
    meta: {
      rule: 'integrations.menu',
      pageTitle: 'Acessos S2S',
      icon: 'KeyIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Integração' },
        { title: 'Acessos S2S', active: true }
      ]
    }
  },
  {
    path: '/integrations/create',
    name: 'integrations-create',
    component: () => import('@/views/apps/integrations/Form.vue'),
    meta: {
      rule: 'integrations.create',
      pageTitle: 'Nova integração S2S',
      icon: 'LinkIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Integração' },
        { title: 'Acessos S2S', url: '/integrations' },
        { title: 'Novo', active: true }
      ]
    }
  },
  {
    path: '/integrations/:id/edit',
    name: 'integrations-edit',
    component: () => import('@/views/apps/integrations/Form.vue'),
    meta: {
      rule: 'integrations.edit',
      pageTitle: 'Editar integração S2S',
      icon: 'LinkIcon',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Integração' },
        { title: 'Acessos S2S', url: '/integrations' },
        { title: 'Editar', active: true }
      ]
    }
  },
  {
    path: '/integration-urls',
    name: 'integration-urls',
    component: () => import('@/views/apps/integration-urls/Index.vue'),
    meta: {
      rule: 'integrations.menu',
      pageTitle: 'URLs de integração',
      icon: 'GlobeIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Integração' },
        { title: 'URLs', active: true }
      ]
    }
  },
  {
    path: '/integration-urls/create',
    name: 'integration-urls-create',
    component: () => import('@/views/apps/integration-urls/Form.vue'),
    meta: {
      rule: 'integrations.create',
      pageTitle: 'Nova URL de integração',
      icon: 'GlobeIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Integração' },
        { title: 'URLs', url: '/integration-urls' },
        { title: 'Novo', active: true }
      ]
    }
  },
  {
    path: '/integration-urls/:id/edit',
    name: 'integration-urls-edit',
    component: () => import('@/views/apps/integration-urls/Form.vue'),
    meta: {
      rule: 'integrations.edit',
      pageTitle: 'Editar URL de integração',
      icon: 'GlobeIcon',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Integração' },
        { title: 'URLs', url: '/integration-urls' },
        { title: 'Editar', active: true }
      ]
    }
  },
  // User Access Logs
  {
    path: '/user-access-logs',
    name: 'user-access-logs',
    component: () => import('@/views/apps/user-access-logs/Index.vue'),
    meta: {
      rule: 'user_access_logs.menu',
      pageTitle: 'Logs de Acesso',
      icon: 'ActivityIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'security.monitoring.menu', url: '/security/dashboard' },
        { title: 'security.access_logs.title', active: true }
      ]
    }
  },
  {
    path: '/users/create',
    name: 'users-create',
    component: () => import('@/views/apps/users/Form.vue'),
    props: true,
    meta: {
      rule: 'users.create',
      pageTitle: 'Registrar Usuário',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Usuários', url: '/users' },
        { title: 'Novo', active: true }
      ],
      icon: 'UsersIcon'
    }
  },
  {
    path: '/users/:id/edit',
    name: 'users-edit',
    component: () => import('@/views/apps/users/Form.vue'),
    props: true,
    meta: {
      rule: 'users.edit',
      pageTitle: 'Editar Usuário',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Usuários', url: '/users' },
        { title: 'Editar', active: true }
      ],
      searchable: false,
      icon: 'UsersIcon'
    }
  },
  // Role
  {
    path: '/roles',
    name: 'roles',
    component: () => import('@/views/apps/roles/Index.vue'),
    meta: {
      rule: 'roles.menu',
      pageTitle: 'Grupos',
      icon: 'TargetIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Grupos', active: true }
      ]
    }
  },
  {
    path: '/roles/create',
    name: 'roles-create',
    component: () => import('@/views/apps/roles/Form.vue'),
    props: true,
    meta: {
      rule: 'roles.create',
      pageTitle: 'Registrar Grupo',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Grupos', url: '/roles' },
        { title: 'Novo', active: true }
      ],
      icon: 'TargetIcon'
    }
  },
  {
    path: '/roles/:id/edit',
    name: 'roles-edit',
    component: () => import('@/views/apps/roles/Form.vue'),
    props: true,
    meta: {
      rule: 'roles.edit',
      pageTitle: 'Editar Grupo',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Grupos', url: '/roles' },
        { title: 'Editar', active: true }
      ],
      searchable: false,
      icon: 'TargetIcon'
    }
  },
  // Functionality
  {
    path: '/functionalities',
    name: 'functionality-index',
    component: () => import('@/views/apps/functionality/Index.vue'),
    meta: {
      rule: 'functionalities.show',
      pageTitle: 'Funcionalidade',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Funcionalidade', active: true }
      ]
    }
  },
  {
    path: '/functionalities/create',
    name: 'functionality-create',
    props: true,
    component: () => import('@/views/apps/functionality/Form.vue'),
    meta: {
      rule: 'functionalities.create',
      pageTitle: 'Criar Funcionalidade',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Funcionalidade', url: '/functionalities' },
        { title: 'Criar', active: true }
      ]
    }
  },
  {
    path: '/functionalities/:id/edit',
    name: 'functionality-edit',
    props: true,
    component: () => import('@/views/apps/functionality/Form.vue'),
    meta: {
      rule: 'functionalities.edit',
      pageTitle: 'Editar Funcionalidade',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Funcionalidade', url: '/functionalities' },
        { title: 'Editar', active: true }
      ]
    }
  },
  // Natural Entity
  {
    path: '/people/natural_entities',
    name: 'people-natural-entities',
    component: () => import('@/views/apps/people/natural_entities/Index.vue'),
    meta: {
      rule: 'natural_entities.menu',
      pageTitle: 'Pessoas Naturais',
      icon: 'UsersIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Pessoas Naturais', active: true }
      ]
    }
  },
  {
    path: '/people/natural_entities/create',
    name: 'people-natural-entities/create',
    component: () => import('@/views/apps/people/natural_entities/Form.vue'),
    props: true,
    meta: {
      rule: 'natural_entities.create',
      pageTitle: ' Registrar Pessoa Natural',
      icon: 'UsersIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Pessoa Natural', url: '/people/natural_entities' },
        { title: 'Nova', active: true }
      ]
    }
  },
  {
    path: '/people/natural_entities/:natural_entity_id/edit',
    name: 'people-natural-entities-edit',
    component: () => import('@/views/apps/people/natural_entities/Form.vue'),
    props: true,
    meta: {
      rule: 'natural_entities.edit',
      pageTitle: 'Editar Pessoa Natural',
      icon: 'UsersIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Pessoa Natural', url: '/people/natural_entities' },
        { title: 'Editar', active: true }
      ],
      searchable: false
    }
  },
  // Legal Entity
  {
    path: '/people/legal_entities',
    name: 'people-legal-entities',
    component: () => import('@/views/apps/people/legal_entities/Index.vue'),
    meta: {
      rule: 'legal_entities.menu',
      pageTitle: 'Pessoas Jurídicas',
      icon: 'UsersIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Pessoas Jurídicas', active: true }
      ]
    }
  },
  {
    path: '/people/legal_entities/create',
    name: 'people-legal-entities-create',
    component: () => import('@/views/apps/people/legal_entities/Form.vue'),
    props: true,
    meta: {
      rule: 'legal_entities.create',
      pageTitle: 'Registrar Pessoa Jurídica',
      icon: 'UsersIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Pessoa Jurídica', url: '/people/legal_entities' },
        { title: 'Nova', active: true }
      ]
    }
  },
  {
    path: '/people/legal_entities/:id/edit',
    name: 'people-legal-entities-edit',
    component: () => import('@/views/apps/people/legal_entities/Form.vue'),
    props: true,
    meta: {
      rule: 'legal_entities.edit',
      pageTitle: 'Editar Pessoa Jurídica',
      icon: 'UsersIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Pessoa Jurídica', url: '/people/legal_entities' },
        { title: 'Editar', active: true }
      ],
      searchable: false
    }
  },
  // Employee
  {
    path: '/people/employees',
    name: 'people-employees',
    component: () => import('@/views/apps/people/employees/Index.vue'),
    meta: {
      rule: 'employees.menu',
      pageTitle: 'Colaboradores',
      icon: 'UserPlusIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Colaboradores', active: true }
      ]
    }
  },
  {
    path: '/people/employees/create',
    name: 'people-employees/create',
    component: () => import('@/views/apps/people/employees/Form.vue'),
    props: true,
    meta: {
      rule: 'employees.create',
      pageTitle: 'Registrar Colaborador',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Colaboradores', url: '/people/employees' },
        { title: 'Novo', active: true }
      ],
      icon: 'UserPlusIcon'
    }
  },
  {
    path: '/people/employees/:id/edit',
    name: 'people-employees-edit',
    component: () => import('@/views/apps/people/employees/Form.vue'),
    props: true,
    meta: {
      rule: 'employees.edit',
      pageTitle: 'Editar Colaborador',
      icon: 'UserPlusIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Colaboradores', url: '/people/employees' },
        { title: 'Editar', active: true }
      ],
      searchable: false
    }
  },
  // PrivacyForm
  {
    path: '/privacy-form',
    name: 'privacy-form',
    component: () => import('@/views/apps/lgpd/handling/Index.vue'),
    meta: {
      rule: 'privacy.form.menu',
      pageTitle: 'Formulário de Privacidade',
      icon: 'CheckSquareIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Privacidade', active: true }
      ]
    }
  },
  {
    path: '/privacy-form/:id/handling',
    name: 'privacy-form-handling',
    component: () => import('@/views/apps/lgpd/handling/FormEdit.vue'),
    props: true,
    meta: {
      rule: 'privacy_form.handling',
      pageTitle: 'Formulário de Privacidade',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Privacidade', url: '/privacy-form' },
        { title: 'Editar', active: true }
      ],
      searchable: false,
      icon: 'CheckSquareIcon'
    }
  },
  {
    path: '/privacy-form/:id',
    name: 'privacy-form-detail',
    component: () => import('@/views/apps/lgpd/handling/FormDetail.vue'),
    props: true,
    meta: {
      rule: 'privacy_form.detail',
      pageTitle: 'Detalhar Formulário de Privacidade',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Privacidade', url: '/privacy-form' },
        { title: 'Detalhes', active: true }
      ],
      searchable: false,
      icon: 'CheckSquareIcon'
    }
  },
  // Schedules
  {
    path: '/schedules',
    name: 'schedules',
    component: () => import('@/views/apps/schedules/SchedulesForm.vue'),
    meta: {
      rule: 'schedules.menu',
      pageTitle: 'Agendamentos',
      icon: 'CalendarIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Agendamentos', active: true }
      ]
    }
  },
  // Incident Form
  {
    path: '/incident-form',
    name: 'incident-form',
    component: () => import('@/views/apps/incident/handling/Index.vue'),
    meta: {
      rule: 'incident.form.menu',
      pageTitle: 'Formulário de Incidente',
      icon: 'CheckSquareIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Incidente', active: true }
      ]
    }
  },
  {
    path: '/incident-form/:id/handling',
    name: 'incident-form-handling',
    component: () => import('@/views/apps/incident/handling/FormHandling.vue'),
    props: true,
    meta: {
      rule: 'incident_form.handling',
      pageTitle: 'Formulário de Incidente - Tratamento',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Incidente', url: '/incident-form' },
        { title: 'Tratamento', active: true }
      ],
      searchable: false,
      icon: 'CheckSquareIcon'
    }
  },
  {
    path: '/incident-form/:id/edit',
    name: 'incident-form-handling-edit',
    component: () => import('@/views/apps/incident/handling/FormEdit.vue'),
    props: true,
    meta: {
      rule: 'incident_form.edit',
      pageTitle: 'Formulário de Incidente - Edição',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Incidente', url: '/incident-form' },
        { title: 'Editar', active: true }
      ],
      searchable: false,
      icon: 'EditIcon'
    }
  },
  {
    path: '/incident-form/:id',
    name: 'incident-form-detail',
    component: () => import('@/views/apps/incident/handling/FormDetail.vue'),
    props: true,
    meta: {
      rule: 'incident_form.detail',
      pageTitle: 'Formulário de Incidente - Detalhes',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Incidente', url: '/incident-form' },
        { title: 'Detalhes', active: true }
      ],
      searchable: false,
      icon: 'EyeIcon'
    }
  },
  // Contacts
  {
    path: '/contact-lists',
    name: 'contact-list-index',
    component: () => import('@/views/apps/contacts/list/Index.vue'),
    props: false,
    meta: {
      rule: 'contact_lists.show',
      pageTitle: 'Contatos - Listas',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Contatos - Listas', active: true }
      ]
    }
  },
  {
    path: '/contact-lists/create',
    name: 'contact-list-create',
    component: () => import('@/views/apps/contacts/list/Form.vue'),
    props: false,
    meta: {
      rule: 'contact_lists.create',
      pageTitle: 'Nova Lista de Contato',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Contatos - Listas', url: '/contact-lists' },
        { title: 'Nova', active: true }
      ]
    }
  },
  {
    path: '/contact-lists/:id/edit',
    name: 'contact-list-edit',
    component: () => import('@/views/apps/contacts/list/Form.vue'),
    props: true,
    meta: {
      rule: 'contact_lists.edit',
      pageTitle: 'Editar Lista de Contato',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Contatos - Listas', url: '/contact-lists' },
        { title: 'Editar', active: true }
      ]
    }
  },
  // Contacts
  {
    path: '/contacts',
    name: 'contact-index',
    component: () => import('@/views/apps/contacts/Index.vue'),
    meta: {
      rule: 'contacts.show',
      pageTitle: 'Contatos - Registros',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Contatos - Registros', active: true }
      ]
    }
  },
  {
    path: '/contacts/create',
    name: 'contact-edit',
    component: () => import('@/views/apps/contacts/Form.vue'),
    meta: {
      rule: 'contacts.edit',
      pageTitle: 'Criar Contato',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Contatos - Registros', url: '/contacts' },
        { title: 'Criar', active: true }
      ]
    }
  },
  {
    path: '/contacts/:id/edit',
    name: 'contact-list-edit',
    component: () => import('@/views/apps/contacts/Form.vue'),
    props: true,
    meta: {
      rule: 'contacts.edit',
      pageTitle: 'Editar Contato',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Contatos - Registros', url: '/contacts' },
        { title: 'Editar', active: true }
      ]
    }
  },
  // Due Diligence
  {
    path: '/due-diligence-form',
    name: 'due-diligence-form-index',
    component: () =>
      import('@/views/apps/forms/due-diligence/DueDiligenceIndex.vue'),
    meta: {
      rule: 'due_diligence_form.menu',
      pageTitle: 'Formulário de Análise de Fornecedores',
      icon: 'CheckSquareIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Análise de Fornecedores', active: true }
      ]
    }
  },
  {
    path: '/due-diligence-form/:id',
    name: 'due-diligence-form-detail',
    component: () =>
      import('@/views/apps/forms/due-diligence/DueDiligenceDetails.vue'),
    props: true,
    meta: {
      rule: 'due_diligence_form.menu',
      pageTitle: 'Formulário de Análise de Fornecedores',
      icon: 'CheckSquareIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Análise de Fornecedores', url: '/due-diligence-form' },
        { title: 'Detalhes', active: true }
      ]
    }
  },
  {
    path: '/configuration/forms',
    name: 'configuration-forms-index',
    component: () =>
      import('@/views/apps/configuration/forms/Index.vue'),
    meta: {
      rule: 'configuration.forms.menu',
      pageTitle: 'Formulários',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Configuração', url: '#' },
        { title: 'Formulários', active: true }
      ],
      icon: 'SettingsIcon'
    }
  },
  // Knowledge Items
  {
    path: '/knowledge/items',
    name: 'knowledge-item-index',
    component: () => import('@/views/apps/knowledge/Index.vue'),
    meta: {
      rule: 'knowledge_items.show',
      pageTitle: 'Gestão de Base de Conhecimento',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Gestão de Base de Conhecimento', active: true }
      ]
    }
  },
  {
    path: '/knowledge/items/create',
    name: 'knowledge-item-create',
    component: () => import('@/views/apps/knowledge/Form.vue'),
    meta: {
      rule: 'knowledge_items.edit',
      pageTitle: 'Criar Base de Conhecimento',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Base de Conhecimento', url: '/knowledge/items' },
        { title: 'Criar', active: true }
      ]
    }
  },
  {
    path: '/knowledge/items/:id',
    name: 'knowledge-item-detail',
    component: () => import('@/views/apps/knowledge/FormDetail.vue'),
    props: true,
    meta: {
      rule: 'knowledge_items.detail',
      pageTitle: 'Detalhar Base de Conhecimento',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Base de Conhecimento', url: '/knowledge/items' },
        { title: 'Detalhes', active: true }
      ]
    }
  },
  {
    path: '/knowledge/items/:id/edit',
    name: 'knowledge-item-edit',
    component: () => import('@/views/apps/knowledge/Form.vue'),
    props: true,
    meta: {
      rule: 'knowledge_items.edit',
      pageTitle: 'Editar Base de Conhecimento',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Base de Conhecimento', url: '/knowledge/items' },
        { title: 'Editar', active: true }
      ]
    }
  },
  {
    path: '/knowledge/consult',
    name: 'knowledge-item-consult',
    component: () => import('@/views/apps/knowledge/IndexConsult.vue'),
    meta: {
      //rule: 'knowledge_items_consult.show',
      rule: 'knowledge_items.show',
      pageTitle: 'Consultar Base de Conhecimento',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Consultar Base de Conhecimento', active: true }
      ]
    }
  },
  {
    path: '/knowledge/consult/:id',
    name: 'knowledge-item-consult-detail',
    component: () => import('@/views/apps/knowledge/FormDetailConsult.vue'),
    props: true,
    meta: {
      //rule: 'knowledge_items_consult.detail',
      rule: 'knowledge_items.detail',
      pageTitle: 'Detalhar Base de Conhecimento',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Consultar Base de Conhecimento', url: '/knowledge/consult' },
        { title: 'Detalhes', active: true }
      ]
    }
  },
  // Documents
  {
    path: '/documents',
    name: 'document-index',
    component: () => import('@/views/apps/documents/Index.vue'),
    meta: {
      rule: 'documents.show',
      pageTitle: 'Gestão de Documentos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Gestão de Documentos', active: true }
      ]
    }
  },
  {
    path: '/documents/create',
    name: 'document-create',
    component: () => import('@/views/apps/documents/Form.vue'),
    meta: {
      rule: 'documents.edit',
      pageTitle: 'Cadastrar Documentos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Gestão de Documentos', url: '/documents' },
        { title: 'Cadastrar', active: true }
      ]
    }
  },
  {
    path: '/documents/:id',
    name: 'document-detail',
    component: () => import('@/views/apps/documents/FormDetail.vue'),
    props: true,
    meta: {
      rule: 'documents.detail',
      pageTitle: 'Detalhar Documentos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Gestão de Documentos', url: '/documents' },
        { title: 'Detalhes', active: true }
      ]
    }
  },
  {
    path: '/documents/:id/edit',
    name: 'document-edit',
    component: () => import('@/views/apps/documents/Form.vue'),
    props: true,
    meta: {
      rule: 'documents.edit',
      pageTitle: 'Editar Documento',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Gestão de Documentos', url: '/documents' },
        { title: 'Editar', active: true }
      ]
    }
  },
  {
    path: '/documents/consult',
    name: 'document-consult-index',
    component: () => import('@/views/apps/documents/IndexConsult.vue'),
    meta: {
      rule: 'knowledge_items.show',
      pageTitle: 'Consulta Documentação',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Consulta Documentação', active: true }
      ]
    }
  },
  {
    path: '/documents/consult/:id',
    name: 'document-consult-detail',
    component: () => import('@/views/apps/documents/FormDetailConsult.vue'),
    props: true,
    meta: {
      rule: 'documents.detail',
      pageTitle: 'Detalhar Documentação',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Consulta Documentação', url: '/documents/consult' },
        { title: 'Detalhes', active: true }
      ]
    }
  },
  {
    path: '/drive',
    name: 'drive-index',
    component: () => import('@/views/apps/drive/FileExplorer.vue'),
    props: true,
    meta: {
      pageTitle: 'Drive',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Drive', active: true }
      ],
      icon: 'FolderIcon',
      searchable: false
    }
  },
  //----
  // Systematic Intimidation Form
  {
    path: '/intimidation-form',
    name: 'intimidation_form_index',
    component: () =>
      import('@/views/apps/intimidation-form/handling/Index.vue'),
    meta: {
      rule: 'intimidation_form_handling.menu',
      pageTitle: 'Formulário de Intimidação Sistemática',
      icon: 'EyeIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Intimidação Sistemática', active: true }
      ]
    }
  },
  {
    path: '/intimidation-form/:id/handling',
    name: 'intimidation_form_handling',
    component: () =>
      import('@/views/apps/intimidation-form/handling/FormEdit.vue'),
    props: true,
    meta: {
      rule: 'intimidation_form_handling.handling',
      pageTitle: 'Formulário de Intimidação Sistemática',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário Intimidação Sistemática', url: '/intimidation-form' },
        { title: 'Editar', active: true }
      ],
      searchable: false,
      icon: 'EyeIcon'
    }
  },
  {
    path: '/intimidation-form/:id',
    name: 'intimidation_form_handling_detail',
    component: () =>
      import('@/views/apps/intimidation-form/handling/FormDetail.vue'),
    props: true,
    meta: {
      rule: 'intimidation_form_handling.detail',
      pageTitle: 'Detalhar Formulário Intimidação Sistemática',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        {
          title: 'Formulário Intimidação Sistemática',
          url: '/intimidation-form'
        },
        { title: 'Detalhes', active: true }
      ],
      searchable: false,
      icon: 'EyeIcon'
    }
  },
  //----
  // Reporting Channel Form
  {
    path: '/reporting-channel',
    name: 'reporting_channel_index',
    component: () =>
      import('@/views/apps/reporting-channel/handling/Index.vue'),
    meta: {
      rule: 'reporting_channel_handling.menu',
      pageTitle: 'Formulário de Relato',
      icon: 'MehIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Relato', active: true }
      ]
    }
  },
  {
    path: '/reporting-channel/dashboard',
    name: 'reporting_channel_dashboard_index',
    component: () =>
      import('@/views/apps/reporting-channel/dashboard/Index.vue'),
    meta: {
      rule: 'reporting_channel_handling.dashboard.menu',
      pageTitle: 'Dashboard - Formulário de Relato',
      icon: 'BarChartIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Relato', url: '/reporting-channel' },
        { title: 'Dashboard', active: true }
      ]
    }
  },
  {
    path: '/reporting-channel/screening',
    name: 'reporting_channel_screening_index',
    component: () =>
      import('@/views/apps/reporting-channel/screening/Index.vue'),
    meta: {
      rule: 'reporting_channel_handling.screening.menu',
      pageTitle: 'Triagem - Formulário de Relato',
      icon: 'FilterIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Relato', url: '/reporting-channel' },
        { title: 'Triagem', active: true }
      ]
    }
  },
  {
    path: '/reporting-channel/:id/screening',
    name: 'reporting_channel_screening_edit',
    component: () =>
      import('@/views/apps/reporting-channel/screening/FormEdit.vue'),
    props: true,
    meta: {
      rule: 'reporting_channel_handling.screening.edit',
      pageTitle: 'Editar Triagem - Formulário de Relato',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        {
          title: 'Triagem - Formulário de Relato',
          url: '/reporting-channel/screening'
        },
        { title: 'Editar', active: true }
      ],
      searchable: false,
      icon: 'FilterIcon'
    }
  },
  {
    path: '/reporting-channel/:id/handling',
    name: 'reporting_channel_handling',
    component: () =>
      import('@/views/apps/reporting-channel/handling/FormEdit.vue'),
    props: true,
    meta: {
      rule: 'reporting_channel_handling.handling',
      pageTitle: 'Formulário de Relato',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Relato', url: '/reporting-channel' },
        { title: 'Editar', active: true }
      ],
      searchable: false,
      icon: 'MehIcon'
    }
  },
  {
    path: '/reporting-channel/:id/print',
    name: 'reporting_channel_handling_print',
    component: () =>
      import('@/views/apps/reporting-channel/handling/FormPrint.vue'),
    props: true,
    meta: {
      layout: 'full',
      rule: 'reporting_channel_handling.detail',
      pageTitle: 'Formulário de Relato',
      searchable: false
    }
  },
  {
    path: '/reporting-channel/:id',
    name: 'reporting_channel_handling_detail',
    component: () =>
      import('@/views/apps/reporting-channel/handling/FormDetail.vue'),
    props: true,
    meta: {
      rule: 'reporting_channel_handling.detail',
      pageTitle: 'Detalhar Formulário de Relato',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Relato', url: '/reporting-channel' },
        { title: 'Detalhes', active: true }
      ],
      searchable: false,
      icon: 'MehIcon'
    }
  },
  // Handling Status Deadline Configuration (específico para ReportingChannel)
  {
    path: '/reporting-channel/config',
    name: 'handling_status_configuration_index',
    component: () => import('@/views/apps/reporting-channel/config/Index.vue'),
    meta: {
      rule: 'reporting_channel_handling.configuration.menu',
      pageTitle: 'Configuração de Formulário de Relato',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Relato', url: '/reporting-channel' },
        { title: 'Configuração', active: true }
      ],
      icon: 'SettingsIcon'
    }
  },
  {
    path: '/reporting-channel/config/create',
    name: 'handling_status_configuration_create',
    component: () => import('@/views/apps/reporting-channel/config/Form.vue'),
    meta: {
      rule: 'reporting_channel_handling.configuration.create',
      pageTitle: 'Criar Configuração',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Relato', url: '/reporting-channel' },
        {
          title: 'Configuração',
          url: '/reporting-channel/config'
        },
        { title: 'Criar', active: true }
      ],
      icon: 'SettingsIcon'
    }
  },
  {
    path: '/reporting-channel/config/:id/edit',
    name: 'handling_status_configuration_edit',
    component: () => import('@/views/apps/reporting-channel/config/Form.vue'),
    props: true,
    meta: {
      rule: 'reporting_channel_handling.configuration.edit',
      pageTitle: 'Editar Configuração',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Relato', url: '/reporting-channel' },
        {
          title: 'Configuração',
          url: '/reporting-channel/config'
        },
        { title: 'Editar', active: true }
      ],
      icon: 'SettingsIcon'
    }
  },
  // Relatórios - Tempo de Atendimento
  {
    path: '/reporting-channel/reports/response-time',
    name: 'reporting_channel_reports_response_time_index',
    component: () =>
      import('@/views/apps/reporting-channel/reports/response-time/Index.vue'),
    meta: {
      rule: 'reporting_channel_handling.reports.response_time.menu',
      pageTitle: 'Relatório de Tempo de Atendimento',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Relato', url: '/reporting-channel' },
        { title: 'Relatórios', url: '#' },
        { title: 'Tempo de Atendimento', active: true }
      ],
      icon: 'ClockIcon'
    }
  },
  // Relatórios - Por Tipo de Relato
  {
    path: '/reporting-channel/reports/type-reporting',
    name: 'reporting_channel_reports_type_reporting_index',
    component: () =>
      import('@/views/apps/reporting-channel/reports/type-reporting/Index.vue'),
    meta: {
      rule: 'reporting_channel_handling.reports.type_reporting.menu',
      pageTitle: 'Relatório por Tipo de Relato',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Relato', url: '/reporting-channel' },
        { title: 'Relatórios', url: '#' },
        { title: 'Por Tipo de Relato', active: true }
      ],
      icon: 'FileTextIcon'
    }
  },
  // Relatórios - Por Identificação
  {
    path: '/reporting-channel/reports/identification',
    name: 'reporting_channel_reports_identification_index',
    component: () =>
      import('@/views/apps/reporting-channel/reports/identification/Index.vue'),
    meta: {
      rule: 'reporting_channel_handling.reports.identification.menu',
      pageTitle: 'Relatório por Identificação',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Relato', url: '/reporting-channel' },
        { title: 'Relatórios', url: '#' },
        { title: 'Por Identificação', active: true }
      ],
      icon: 'UserCheckIcon'
    }
  },
  // Relatórios - Por Nível de Criticidade
  {
    path: '/reporting-channel/reports/severity',
    name: 'reporting_channel_reports_severity_index',
    component: () =>
      import('@/views/apps/reporting-channel/reports/severity/Index.vue'),
    meta: {
      rule: 'reporting_channel_handling.reports.severity.menu',
      pageTitle: 'Relatório por Nível de Criticidade',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Formulário de Relato', url: '/reporting-channel' },
        { title: 'Relatórios', url: '#' },
        { title: 'Por Nível de Criticidade', active: true }
      ],
      icon: 'TrendingUpIcon'
    }
  },
  // Newsletter
  {
    path: '/newsletters',
    name: 'newsletter-index',
    component: () => import('@/views/apps/newsletter/Index.vue'),
    meta: {
      rule: 'newsletters.show',
      pageTitle: 'Informativos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Informativos', active: true }
      ]
    }
  },
  {
    path: '/newsletters/create',
    name: 'newsletter-create',
    component: () => import('@/views/apps/newsletter/Form.vue'),
    meta: {
      rule: 'newsletters.create',
      pageTitle: 'Cadastrar Informativo',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Informativos', url: '/newsletters' },
        { title: 'Cadastrar', active: true }
      ]
    }
  },
  {
    path: '/newsletters/:id',
    name: 'newsletter-detail',
    component: () => import('@/views/apps/newsletter/FormDetail.vue'),
    props: true,
    meta: {
      rule: 'newsletters.detail',
      pageTitle: 'Detalhar Informativo',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Informativos', url: '/newsletters' },
        { title: 'Detalhes', active: true }
      ]
    }
  },
  {
    path: '/newsletters/:id/edit',
    name: 'newsletter-edit',
    component: () => import('@/views/apps/newsletter/Form.vue'),
    props: true,
    meta: {
      rule: 'newsletters.edit',
      pageTitle: 'Editar Informativo',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Informativos', url: '/newsletters' },
        { title: 'Editar', active: true }
      ]
    }
  },
  {
    path: '/newsletters-moderator',
    name: 'newsletter-moderator-index',
    component: () => import('@/views/apps/newsletter/moderator/Index.vue'),
    props: true,
    meta: {
      rule: 'newsletters_moderator.grid',
      pageTitle: 'Informativos - Moderação',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Informativos - Moderação', active: true }
      ]
    }
  },
  {
    path: '/newsletters-moderator/:id/comments',
    name: 'newsletter-moderator-comments',
    component: () =>
      import('@/views/apps/newsletter/moderator/NewsletterModerator.vue'),
    props: true,
    meta: {
      rule: 'newsletters_moderator.show',
      pageTitle: 'Informativos - Moderação',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Informativos - Moderação', url: '/newsletters-moderator' },
        { title: 'Comentários', active: true }
      ]
    }
  },
  {
    path: '/newsletters/:id/signatures',
    name: 'newsletter-moderator-signatures',
    component: () => import('@/views/apps/newsletter/FormSignatureDetail.vue'),
    props: true,
    meta: {
      rule: 'newsletters.view_signatures',
      pageTitle: 'Informativos - Assinaturas',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Informativos', url: '/newsletters' },
        { title: 'Assinaturas', active: true }
      ]
    }
  },
  // Group News
  {
    path: '/group-news',
    name: 'group-news-index',
    component: () => import('@/views/apps/newsletter/group/Index.vue'),
    meta: {
      rule: 'group_news.show',
      pageTitle: 'Grupo de Informativos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Grupo de Informativos', active: true }
      ]
    }
  },
  {
    path: '/group-news/create',
    name: 'group-news-create',
    component: () => import('@/views/apps/newsletter/group/Form.vue'),
    meta: {
      rule: 'group_news.create',
      pageTitle: 'Cadastrar Grupo de Informativos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Grupo de Informativos', url: '/group-news' },
        { title: 'Cadastrar', active: true }
      ]
    }
  },
  {
    path: '/group-news/:id/edit',
    name: 'group-news-edit',
    component: () => import('@/views/apps/newsletter/group/Form.vue'),
    props: true,
    meta: {
      rule: 'group_news.edit',
      pageTitle: 'Editar Grupo de Informativos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Grupo de Informativos', url: '/group-news' },
        { title: 'Editar', active: true }
      ]
    }
  },
  // Subgroup News
  {
    path: '/subgroup-news',
    name: 'subgroup-news-index',
    component: () => import('@/views/apps/newsletter/subgroup/Index.vue'),
    meta: {
      rule: 'subgroup_news.show',
      pageTitle: 'Subgrupo de Informativos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Subgrupo de Informativos', active: true }
      ]
    }
  },
  {
    path: '/subgroup-news/create',
    name: 'subgroup-news-create',
    component: () => import('@/views/apps/newsletter/subgroup/Form.vue'),
    meta: {
      rule: 'subgroup_news.create',
      pageTitle: 'Cadastrar Subgrupo de Informativos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Subgrupo de Informativos', url: '/subgroup-news' },
        { title: 'Cadastrar', active: true }
      ]
    }
  },
  {
    path: '/subgroup-news/:id/edit',
    name: 'subgroup-news-edit',
    component: () => import('@/views/apps/newsletter/subgroup/Form.vue'),
    props: true,
    meta: {
      rule: 'subgroup_news.edit',
      pageTitle: 'Editar Subgrupo de Informativos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Subgrupo de Informativos', url: '/subgroup-news' },
        { title: 'Editar', active: true }
      ]
    }
  },
  // Newsletter workflow
  {
    path: '/newsletter_workflows',
    name: 'newsletter-workflow-index',
    component: () => import('@/views/apps/newsletter/workflow/Index.vue'),
    props: true,
    meta: {
      rule: 'newsletter_workflows.show',
      pageTitle: 'Workflow de Informativos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Workflow de Informativos', active: true }
      ]
    }
  },
  {
    path: '/newsletter_workflows/create',
    name: 'newsletter-workflow-create',
    component: () => import('@/views/apps/newsletter/workflow/Form.vue'),
    props: true,
    meta: {
      rule: 'newsletter_workflows.create',
      pageTitle: 'Cadastrar Workflow de Informativos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Workflow de Informativos', url: '/newsletter_workflows' },
        { title: 'Cadastrar', active: true }
      ]
    }
  },
  {
    path: '/newsletter_workflows/:id/edit',
    name: 'newsletter-workflow-edit',
    component: () => import('@/views/apps/newsletter/workflow/Form.vue'),
    props: true,
    meta: {
      rule: 'newsletter_workflows.edit',
      pageTitle: 'Editar Workflow de Informativos',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Workflow de Informativos', url: '/newsletter_workflows' },
        { title: 'Editar', active: true }
      ]
    }
  },
  {
    path: '/newsletter_workflows/:id/detail',
    name: 'newsletter-workflow-detail',
    component: () => import('@/views/apps/newsletter/workflow/FormDetail.vue'),
    props: true,
    meta: {
      rule: 'newsletter_workflows.detail',
      pageTitle: 'Dashboard',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Workflow de Informativos', url: '/newsletter_workflows' },
        { title: 'Dashboard', active: true }
      ]
    }
  },
  // Portal CEBAS
  {
    path: '/portal-cebas/credentialings/configs',
    name: 'portal-cebas-credentialing-config-index',
    component: () =>
      import('@/views/apps/portal-cebas/credentialing/ConfigIndex.vue'),
    meta: {
      rule: 'portal_cebas.credentialing.config.grid',
      pageTitle: 'Configuração',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Portal CEBAS', url: '#' },
        { title: 'Configuração', active: true }
      ]
    }
  },
  {
    path: '/portal-cebas/credentialings/configs/create',
    name: 'portal-cebas-credentialing-config-create',
    component: () =>
      import('@/views/apps/portal-cebas/credentialing/ConfigForm.vue'),
    props: true,
    meta: {
      rule: 'portal_cebas.credentialing.config.create',
      pageTitle: 'Criar Configuração',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Portal CEBAS', url: '#' },
        { title: 'Configuração', url: '/portal-cebas/credentialings/configs' },
        { title: 'Criar', active: true }
      ]
    }
  },
  {
    path: '/portal-cebas/credentialings/configs/:id/edit',
    name: 'portal-cebas-credentialing-config-edit',
    component: () =>
      import('@/views/apps/portal-cebas/credentialing/ConfigForm.vue'),
    props: true,
    meta: {
      rule: 'portal_cebas.credentialing.config.edit',
      pageTitle: 'Editar Configuração',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Portal CEBAS', url: '#' },
        { title: 'Configuração', url: '/portal-cebas/credentialings/configs' },
        { title: 'Editar', active: true }
      ]
    }
  },
  // Portal CEBAS - handling
  {
    path: '/portal-cebas/credentialings/handlings',
    name: 'portal-cebas-credentialing-handling-index',
    component: () =>
      import(
        '@/views/apps/portal-cebas/credentialing/handling/HandlingIndex.vue'
      ),
    props: true,
    meta: {
      rule: 'portal_cebas.credentialing.handling.grid',
      pageTitle: 'Tratamento',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Portal CEBAS', url: '#' },
        { title: 'Tratamento', active: true }
      ]
    }
  },
  {
    path: '/portal-cebas/credentialings/handlings/:id/handling',
    name: 'portal-cebas-credentialing-handling-handling',
    component: () =>
      import(
        '@/views/apps/portal-cebas/credentialing/handling/HandlingForm.vue'
      ),
    props: true,
    meta: {
      rule: 'portal_cebas.credentialing.handling',
      pageTitle: 'Tratamento',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Portal CEBAS', url: '#' },
        { title: 'Tratamento', url: '/portal-cebas/credentialings/handlings' },
        { title: 'Editar', active: true }
      ]
    }
  },
  {
    path: '/portal-cebas/credentialings/handlings/:id',
    name: 'portal-cebas-credentialing-handling-detail',
    component: () =>
      import(
        '@/views/apps/portal-cebas/credentialing/handling/HandlingFormDetail.vue'
      ),
    props: true,
    meta: {
      rule: 'portal_cebas.credentialing.handling.detail',
      pageTitle: 'Detalhar Tratamento',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Portal CEBAS', url: '#' },
        { title: 'Tratamento', url: '/portal-cebas/credentialings/handlings' },
        { title: 'Detalhes', active: true }
      ]
    }
  },
  {
    path: '/security/dashboard',
    name: 'security-dashboard',
    component: () => import('@/views/apps/security/SecurityDashboard.vue'),
    meta: {
      rule: 'security.dashboard',
      pageTitle: 'Dashboard de monitoramento',
      icon: 'BarChartIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Segurança' },
        { title: 'security.monitoring.menu', url: '/security/dashboard' },
        { title: 'security.dashboard.title', active: true }
      ]
    }
  },
  {
    path: '/security/requests',
    name: 'security-requests',
    component: () => import('@/views/apps/security/SecurityRequests.vue'),
    meta: {
      rule: 'security.requests.view',
      pageTitle: 'Requisições',
      icon: 'FileTextIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Segurança' },
        { title: 'security.monitoring.menu', url: '/security/dashboard' },
        { title: 'security.requests.title', active: true }
      ]
    }
  },
  {
    path: '/security/ips',
    name: 'security-ips',
    component: () => import('@/views/apps/security/SecurityIps.vue'),
    meta: {
      rule: 'security.ips.view',
      pageTitle: 'Análise de IP',
      icon: 'GlobeIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Segurança' },
        { title: 'security.monitoring.menu', url: '/security/dashboard' },
        { title: 'security.ips.title', active: true }
      ]
    }
  },
  {
    path: '/security/ips/:ip',
    name: 'security-ips-detail',
    component: () => import('@/views/apps/security/SecurityIps.vue'),
    props: true,
    meta: {
      rule: 'security.ips.view',
      pageTitle: 'Análise de IP',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Segurança' },
        { title: 'security.ips.title', url: '/security/ips' },
        { title: 'security.ips.detail', active: true }
      ]
    }
  },
  {
    path: '/security/blocked-ips',
    name: 'security-blocked-ips',
    component: () => import('@/views/apps/security/blocked-ips/Index.vue'),
    meta: {
      rule: 'security.blocked_ips.view',
      pageTitle: 'IPs bloqueados',
      icon: 'LockIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Segurança' },
        { title: 'security.monitoring.menu', url: '/security/dashboard' },
        { title: 'security.blocked_ips.title', active: true }
      ]
    }
  },
  {
    path: '/security/blocked-ips/create',
    name: 'security-blocked-ips-create',
    component: () => import('@/views/apps/security/blocked-ips/Form.vue'),
    meta: {
      rule: 'security.blocked_ips.create',
      pageTitle: 'Bloquear IP',
      icon: 'LockIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'security.blocked_ips.title', url: '/security/blocked-ips' },
        { title: 'security.blocked_ips.create_title', active: true }
      ]
    }
  },
  {
    path: '/security/blocked-ips/:id/edit',
    name: 'security-blocked-ips-edit',
    component: () => import('@/views/apps/security/blocked-ips/Form.vue'),
    props: true,
    meta: {
      rule: 'security.blocked_ips.update',
      pageTitle: 'Editar bloqueio de IP',
      icon: 'LockIcon',
      searchable: false,
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'security.blocked_ips.title', url: '/security/blocked-ips' },
        { title: 'security.blocked_ips.edit_title', active: true }
      ]
    }
  },
  {
    path: '/security/ip-block-settings',
    name: 'security-ip-block-settings',
    component: () => import('@/views/apps/security/IpBlockSettings.vue'),
    meta: {
      rule: 'security.ip_block_settings.menu',
      pageTitle: 'Bloqueio por tentativas',
      icon: 'SettingsIcon',
      breadcrumb: [
        { title: 'Mural', url: '/' },
        { title: 'Segurança' },
        { title: 'security.monitoring.menu', url: '/security/dashboard' },
        { title: 'security.ip_block_settings.title', active: true }
      ]
    }
  }
]
